import { create } from 'zustand';

export type Section = 'panel' | 'plano' | 'territorio' | 'seguimiento' | 'ajustes';

interface AppState {
  isDark: boolean;
  setDark: (v: boolean) => void;
  section: Section;
  catActiva: string | null;
  openPinId: string | null;
  activeTool: string;
  selectedPlanoId: string | null;
  searchOpen: boolean;
  rolMenuOpen: boolean;
  userMenuOpen: boolean;
  modalRegistroOpen: boolean;
  viviendaModalOpen: boolean;
  nuevoCat: string;
  nuevoTitulo: string;
  nuevoEnviado: boolean;
  setSelectedPlanoId: (id: string | null) => void;
  filtroEstado: string | null;
  filtroSector: string;
  query: string;
  sortBy: 'fecha' | 'prioridad';
  selectedTicketId: string | null;
  // actions
  setSection: (s: Section) => void;
  filtrarCat: (id: string) => void;
  abrirPopup: (id: string) => void;
  cerrarPopup: () => void;
  setTool: (id: string) => void;
  toggleSearch: () => void;
  toggleRolMenu: () => void;
  toggleUserMenu: () => void;
  abrirRegistrar: () => void;
  cerrarRegistro: () => void;
  abrirVivienda: () => void;
  cerrarVivienda: () => void;
  setNuevoCat: (id: string) => void;
  setNuevoTitulo: (v: string) => void;
  markEnviado: () => void;
  resetRegistro: () => void;
  setFiltroEstado: (id: string | null) => void;
  setFiltroSector: (v: string) => void;
  setQuery: (v: string) => void;
  toggleSort: () => void;
  selectTicket: (id: string) => void;
}

export const useAppStore = create<AppState>()((set) => ({
  isDark: false,
  setDark: (isDark) => set({ isDark }),
  section: 'panel',
  catActiva: null,
  openPinId: null,
  activeTool: 'consultar',
  selectedPlanoId: null,
  searchOpen: false,
  rolMenuOpen: false,
  userMenuOpen: false,
  modalRegistroOpen: false,
  viviendaModalOpen: false,
  nuevoCat: '',
  nuevoTitulo: '',
  nuevoEnviado: false,
  filtroEstado: null,
  filtroSector: '',
  query: '',
  sortBy: 'fecha',
  selectedTicketId: null,

  setSection: (section) => set({ section, openPinId: null, rolMenuOpen: false, userMenuOpen: false }),
  filtrarCat: (id) => set((s) => ({ catActiva: s.catActiva === id ? null : id })),
  abrirPopup: (id) => set({ openPinId: id }),
  cerrarPopup: () => set({ openPinId: null }),
  setTool: (activeTool) => set({ activeTool }),
  toggleSearch: () => set((s) => ({ searchOpen: !s.searchOpen })),
  toggleRolMenu: () => set((s) => ({ rolMenuOpen: !s.rolMenuOpen, userMenuOpen: false })),
  toggleUserMenu: () => set((s) => ({ userMenuOpen: !s.userMenuOpen, rolMenuOpen: false })),
  abrirRegistrar: () => set({ modalRegistroOpen: true, nuevoEnviado: false }),
  cerrarRegistro: () => set({ modalRegistroOpen: false }),
  abrirVivienda: () => set({ viviendaModalOpen: true }),
  cerrarVivienda: () => set({ viviendaModalOpen: false }),
  setNuevoCat: (nuevoCat) => set({ nuevoCat }),
  setNuevoTitulo: (nuevoTitulo) => set({ nuevoTitulo }),
  markEnviado: () => set({ nuevoEnviado: true }),
  resetRegistro: () => set({ nuevoTitulo: '', nuevoEnviado: false, modalRegistroOpen: false }),
  setFiltroEstado: (filtroEstado) => set({ filtroEstado }),
  setFiltroSector: (filtroSector) => set({ filtroSector }),
  setQuery: (query) => set({ query }),
  toggleSort: () => set((s) => ({ sortBy: s.sortBy === 'fecha' ? 'prioridad' : 'fecha' })),
  selectTicket: (selectedTicketId) => set({ selectedTicketId }),
  setSelectedPlanoId: (selectedPlanoId) => set({ selectedPlanoId }),
}));
